import type { ReactNode } from "react";

type PublicPageLayoutProps = {
  children: ReactNode;
  className?: string;
};

export function PublicPageLayout({
  children,
  className = "",
}: PublicPageLayoutProps) {
  return (
    <div className={`relative z-10 min-h-svh text-ink ${className}`.trim()}>
      {children}
    </div>
  );
}
